const mutations = {
   SET_LOADER_ACTIVE (state, text) {
      state.loaderText = text
      state.isLoaderActive = true
   },

   SET_LOADER_INACTIVE(state) {
      state.loaderText = null
      state.isLoaderActive = false
   },
}

export default mutations;